import DialogWithHelpPanelEntry from "~/components/StyleGuide/DialogEntries/DialogWithHelpPanelEntry";
import DialogContentEntry from "./DialogContentEntry";
import DialogInlineEntry from "./DialogInlineEntry";

export default () => [DialogContentEntry(), DialogInlineEntry(), DialogWithHelpPanelEntry()];
